import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const ROLE_STYLE = {
  ROOT_SUPER_ADMIN: { title: "ROOT ADMIN", position: "Platform Owner" },
  SUPER_ADMIN: { title: "SUPER ADMIN", position: "Manager" },
  PARTNER: { title: "PARTNER", position: "Freelancer" },
  BUSINESS_OWNER: { title: "BUSINESS OWNER", position: "Store Admin" },
  CUSTOMER: { title: "MEMBER", position: "Marketplace User" },
  CREATOR: { title: "CREATOR", position: "Video Creator" },
};

const dayCls = (days) => (days <= 0 ? "t-exp" : days <= 2 ? "t-crit" : days <= 5 ? "t-warn" : "");

export default function RoleBadge() {
  const { user } = useAuth();
  const [renewal, setRenewal] = useState(null);

  useEffect(() => {
    setRenewal(null);
    api.get("/auth/renewal").then((r) => setRenewal(r.data)).catch(() => {});
  }, [user?.id, user?.role]);

  if (!user) return null;
  const cfg = ROLE_STYLE[user.role];
  if (!cfg) return null;
  const days = renewal?.days_left;

  return (
    <div className="role-badge" data-testid="role-badge">
      <div className="rb-shine" />
      <p className="rb-title" data-testid="role-badge-title">{cfg.title}</p>
      <p className="rb-sub" data-testid="role-badge-position">
        {cfg.position}
        {days != null && (
          <>
            <span className="rb-dot">·</span>
            <CalendarClock className="h-3 w-3 shrink-0" />
            <span className={`rb-days ${dayCls(days)}`} data-testid="role-badge-days">
              {days <= 0 ? "Expired" : `${days} Day${days === 1 ? "" : "s"} Left`}
            </span>
          </>
        )}
      </p>
    </div>
  );
}
